import { render } from "./plannedTrainingOverview.vue?vue&type=template&id=62855860&scoped=true&ts=true"
import script from "./plannedTrainingOverview.vue?vue&type=script&lang=ts"
export * from "./plannedTrainingOverview.vue?vue&type=script&lang=ts"

import "./plannedTrainingOverview.vue?vue&type=style&index=0&id=62855860&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62855860"]])

export default __exports__